// Theme Colors
// Initially this will be blank. Later on when app is initialized we will assign bootstrap colors to this from CSS variables.
export const $themeColors = {}

// App Breakpoints
// Initially this will be blank. Later on when app is initialized we will assign bootstrap breakpoints to this object from CSS variables.
export const $themeBreakpoints = {}

// APP CONFIG
export const $themeConfig = {
  app: {
    appName: '', // Will update name in navigation menu (Branding)
    // eslint-disable-next-line global-require
    appLogoImage: require('@/assets/images/logo/logo-white.svg'), // Will update logo in navigation menu (Branding)
    appLogoPurpleBlackImage: require('@/assets/images/logo/logo-purple-black.svg'),
    // The same lockup with white lettering, for the header in dark mode.
    appLogoPurpleWhiteImage: require('@/assets/images/logo/logo-purple-white.svg'),
    // Icon-only mark (202x228). The wordmark above is 200x44 — a 4.5:1 ratio
    // that renders 6-10px tall once a phone header squeezes it, which is not
    // legible. The header shows this instead below `md`.
    // It is login-main-logo.svg recoloured: that one is white, for the dark
    // sign-in background, and so is invisible on the white header bar.
    // eslint-disable-next-line global-require
    appLogoMarkImage: require('@/assets/images/logo/logo-mark-purple.svg'), // Will update logo in navigation menu (Branding)
    // The black wordmark, for the header under any accent but the default: the
    // brand purple clashes with a community's own colour. (Phones then show no
    // mark: HorizontalMenu.)
    // eslint-disable-next-line global-require
    appLogoBlackImage: require('@/assets/images/logo/logo-black.svg'),
  },
  layout: {
    isRTL: false,
    skin: 'light', // light, dark, bordered, semi-dark
    routerTransition: 'zoom-fade', // zoom-fade, slide-fade, fade-bottom, fade, zoom-out, none
    type: 'vertical', // vertical, horizontal
    contentWidth: 'full', // full, boxed
    menu: {
      hidden: false,
      isCollapsed: false,
    },
    navbar: {
      // ? For horizontal menu, navbar type will work for navMenu type
      type: 'floating', // static , sticky , floating, hidden
      backgroundColor: '', // BS color options [primary, success, etc]
    },
    footer: {
      type: 'static', // static, sticky, hidden
    },
    customizer: true,
    enableScrollToTop: true,
  },
}
